import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { AdminService } from '../admin.service';
import 'rxjs/add/operator/switchMap';

@Component({
  selector: 'app-admin-detail',
  template: require('./admin-detail.component.html'),
  styles: [require('./admin-detail.component.scss')],
})
export class AdminDetailComponent implements OnInit {
  object: any;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public adminService: AdminService,
  ) { }

  ngOnInit(): void {
    this.route.params
      .switchMap((params: Params) => {
        this.adminService.className = params.className;
        this.adminService.loadSchema();

        return this.adminService.getById(params.id);
      })
      .subscribe((object) => this.object = object);
  }

  deleteItem(object: any) {
    this.adminService.delete(object)
      .then((response) => {
        this.router.navigate([`/admin/${this.adminService.className}`]);
      })
      .catch((err) => {
        console.error(err);
      });
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/admin/admin-detail/admin-detail.component.ts